export const LANGUAGE_CODES = {
	af: "Afrikaans",
	sq: "Albanian",
	ar: "Arabic",
	hy: "Armenian",
	as: "Assamese",
	az: "Azerbaijani",
	eu: "Basque",
	be: "Belarusian",
	bn: "Bengali",
	bs: "Bosnian",
	bg: "Bulgarian",
	my: "Burmese",
	ca: "Catalan",
	"zh-CN": "Chinese (Simplified)",
	"zh-TW": "Chinese (Traditional)",
	hr: "Croatian",
	cs: "Czech",
	da: "Danish",
	nl: "Dutch",
	en: "English",
	et: "Estonian",
	tl: "Filipino",
	fi: "Finnish",
	fr: "French",
	gl: "Galician",
	ka: "Georgian",
	de: "German",
	gsw: "Swiss German",
	el: "Greek",
	gu: "Gujarati",
	ht: "Haitian Creole",
	ha: "Hausa",
	he: "Hebrew",
	hi: "Hindi",
	hu: "Hungarian",
	is: "Icelandic",
	ig: "Igbo",
	id: "Indonesian",
	ga: "Irish",
	it: "Italian",
	ja: "Japanese",
	jv: "Javanese",
	kn: "Kannada",
	kk: "Kazakh",
	km: "Khmer",
	rw: "Kinyarwanda",
	ko: "Korean",
	ku: "Kurdish",
	ky: "Kyrgyz",
	lo: "Lao",
	lv: "Latvian",
	lt: "Lithuanian",
	lb: "Luxembourgish",
	mk: "Macedonian",
	mg: "Malagasy",
	ms: "Malay",
	ml: "Malayalam",
	mt: "Maltese",
	mi: "Maori",
	mr: "Marathi",
	mn: "Mongolian",
	ne: "Nepali",
	no: "Norwegian",
	or: "Oriya",
	om: "Oromo",
	ps: "Pashto",
	fa: "Persian",
	pl: "Polish",
	pt: "Portuguese",
	pa: "Punjabi",
	ro: "Romanian",
	ru: "Russian",
	sm: "Samoan",
	gd: "Scots Gaelic",
	sr: "Serbian",
	st: "Sesotho",
	sn: "Shona",
	sd: "Sindhi",
	si: "Sinhala",
	sk: "Slovak",
	sl: "Slovenian",
	so: "Somali",
	es: "Spanish",
	su: "Sundanese",
	sw: "Swahili",
	sv: "Swedish",
	tg: "Tajik",
	ta: "Tamil",
	tt: "Tatar",
	te: "Telugu",
	th: "Thai",
	ti: "Tigrinya",
	to: "Tongan",
	tr: "Turkish",
	tk: "Turkmen",
	uk: "Ukrainian",
	ur: "Urdu",
	uz: "Uzbek",
	vi: "Vietnamese",
	cy: "Welsh",
	wo: "Wolof",
	xh: "Xhosa",
	yi: "Yiddish",
	yo: "Yoruba",
	zu: "Zulu",
}

export const getLanguageName = (locale, i18nLang = null) => {
	if (!locale) return ""

	if (locale === "gsw") return LANGUAGE_CODES[locale]

	return (
		new Intl.DisplayNames([i18nLang || "en"], { type: "language" })?.of(
			locale,
		) || ""
	)
}
